import React, { useContext } from "react";
import { Text, InlineStack, BlockStack } from "@shopify/polaris";
import PropTypes from "prop-types";
import { withErrorBoundary, withFeature } from "lib/hoc";
import constant from "lib/constant/constant";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";
import ConsignmentShip from "app/setup/modules/operator/features/_fulfillment/generic/consignmentShip/consignmentShip";

const DefaultConsignmentShip = (props) => {
  const { cms } = useContext(FulfillmentContext);
  const { value } = props;
  return (
    <>
      <BlockStack gap="8">
        <InlineStack>
          <Text variant="headingMd" as="h2">
            {cms("hybrid.consignmentShip.title")}
          </Text>
          {/* 
            <Link onClick={() => learnMore(cms("hybrid.consignmentShip.title"), cms("hybrid.consignmentShip.title"))}>
              {cms("common.learnMore")}
            </Link>
           */}
          <br />
          <Text as="span" tone="subdued">
            {cms("hybrid.consignmentShip.description")}
          </Text>
        </InlineStack>
      </BlockStack>
      <br />
      <ConsignmentShip method="defaultConsignmentShip" value={value} />
    </>
  );
};

DefaultConsignmentShip.propTypes = {
  value: PropTypes.string.isRequired,
};

export default withFeature(withErrorBoundary(DefaultConsignmentShip), { feature: constant.CONSIGNMENT_SHIP });
